import ikea from 'ikea-jssdk';
import React from 'react';
import ReactDOM from 'react-dom';

import '@aidesign/aid-base/build/aid-base.css';
import '@aidesign/store/dist/index.rem.css';
import './index.css';
import { getAbTestResult } from './utils/abTestUtils.js';
// import VConsole from 'vconsole';

import App from './App';
import './intl18/index';
import reportWebVitals from './reportWebVitals';
import { currentPlatform, getUserInfo } from './adaptPlatform';

if (process.env.REACT_APP_ENV !== 'production') {
  // eslint-disable-next-line global-require
  // const VConsole = require('vconsole');
  // eslint-disable-next-line
  // var vConsole = new VConsole();
}
if (window.location.href.includes('type=link')) {
  // 判断是否扫码进入，退出用
  sessionStorage.setItem('typelink', true);
}

if (process.env.REACT_APP_ENV === 'production') {
  ikea.init({
    refer: {
      referId: 'kitchen-online',
    },
    env: 'prod', // 这里这么写上面说过，如果不明白请往上看看
  });
} else {
  ikea.init({
    refer: {
      referId: 'kitchen-online',
    },
    env: 'qa', // 这里这么写上面说过，如果不明白请往上看看
  });
}

async function initFn() {
  const platform = await currentPlatform();
  const typeObj = {
    WechatMiniprogram: 'smp',
    Harmony: 'app',
    ANDROID: 'app',
    iOS: 'app',
    PcWeb: 'ikeacn',
    MobileWeb: 'ikeacn',
    unknown: 'ikeacn',
  };
  localStorage.setItem('platform', typeObj[platform]);
  localStorage.setItem('currentPlatform', typeObj[platform]);
  let gioPlatform;
  switch (platform) {
    case 'iOS':
      gioPlatform = 'iOS';
      break;
    case 'ANDROID':
      gioPlatform = 'Android';
      break;
    case 'WechatMiniprogram':
      gioPlatform = 'WechatMiniprogram';
      break;
    case 'PcWeb':
      gioPlatform = 'pc';
      break;
    case 'MobileWeb':
      gioPlatform = 'h5';
      break;
    case 'Harmony':
      gioPlatform = 'Harmony';
      break;
    // case 'unknown':
    default:
      gioPlatform = 'h5';
      break;
  }
  localStorage.setItem('gioPlatform', gioPlatform);

  // 3105AB测试
  // A方案删除内容
  // const storageUser = await ikea.abtest.getVariation({
  //   // 实验id
  //   experimentId: 'Quotation_interior_bundle',
  //   // 如果数据获取失败的默认数据
  //   defaultVariation: 'AUser',
  // });
  // if (
  //   localStorage.getItem('currentPlatform') === 'app'
  //   && !localStorage.getItem('storageUser')
  // ) {
  //   localStorage.setItem('storageUser', storageUser.value);
  // }

  // if (localStorage.getItem('storageUser')) {
  //   window.gio(
  //     'visitor.set',
  //     'abtest_kit_interior_bundle',
  //     localStorage.getItem('storageUser'),
  //   );
  // }
  // A方案删除内容

  // AB实验
  // await getAbTestResult('kit_add_guide_lastStep', 'HIDE', 'lastStepAddGuide');

  // 3144AB实验
  // await getAbTestResult('kit_one_click_retention', 'HIDE', 'oneClickRetention');
  // 3127AB测试
  // const oneClickBack = await ikea.abtest.getVariation({
  //   // 实验id
  //   experimentId: 'Kitchen_one_click_back',
  //   // 如果数据获取失败的默认数据
  //   defaultVariation: 'AUser',
  // });
  // if (localStorage.getItem('currentPlatform') === 'app' && !localStorage.getItem('oneClickUser')) {
  //   localStorage.setItem('oneClickUser', oneClickBack.value);
  // }
  // if (localStorage.getItem('onClickUser')) {
  //   window.gio('visitor.set', 'abtest_kit_oneclick_back', localStorage.getItem('oneClickUser'));
  // }

  await getAbTestResult('kitchen_low_price', 'SHOW', 'abtestLowPrice');

  getUserInfo((result) => {
    console.log('zhuwenjie a', result);
    if (!result) return;
    if (result.value.hashedPartyUid) {
      window.gio('setUserId', result.value.hashedPartyUid);
      window.gio('visitor.set', 'kit_login_status', '已登录');
    } else {
      window.gio('clearUserId');
      window.gio('visitor.set', 'kit_login_status', '未登录');
    }
  });

  ReactDOM.render(<App />, document.getElementById('root'));
}

initFn();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
